/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import useSWR from 'swr';
import qs from 'qs';

import request from '@/utils/request';
import type * as Type from '@/common/interface';

export const useAdminVideos = (params: Type.VideoAdminListReq) => {
  const apiUrl = `/answer/admin/api/videos?${qs.stringify(params, {
    skipNulls: true,
  })}`;
  const { data, error, mutate } = useSWR<
    Type.ListResult<Type.VideoAdminItem>,
    Error
  >([apiUrl], request.instance.get);
  return {
    data,
    isLoading: !data && !error,
    error,
    mutate,
  };
};

export const useAdminVideoStats = (params: Type.VideoStatsReq) => {
  const apiUrl = `/answer/admin/api/videos/stats?${qs.stringify(params, {
    skipNulls: true,
  })}`;
  const { data, error, mutate } = useSWR<Type.VideoStatsResp, Error>(
    [apiUrl],
    request.instance.get,
  );
  return {
    data,
    isLoading: !data && !error,
    error,
    mutate,
  };
};

export const saveAdminVideo = (params: Type.VideoAdminSaveReq) => {
  if (params.id) {
    return request.put<Type.VideoAdminItem>('/answer/admin/api/videos', params);
  }
  return request.post<Type.VideoAdminItem>('/answer/admin/api/videos', params);
};

export const updateVideoFromNodeCallback = (
  params: Type.VideoNodeCallbackReq,
) => {
  return request.post<Type.VideoNodeCallbackResp>(
    '/answer/admin/api/videos/node-callback',
    params,
  );
};
